export default __webpack_public_path__ + "static/media/DNo.39-1.a0b97cb6.jpg";